module.exports = __webpack_public_path__ + "static/media/map-min.55b19fc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/map-min.png
// module id = 462
// module chunks = 0